<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l(
                  'INDEX.header_search_placeholder_production_order_proofin'
                ) || '产品规格编号/产品规格名称/打样类型/需求数量搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-form-item
            :label="$l('INDEX.proofing_label_proofingType') || '打样类型'"
          >
            <dict-select
              v-model="form.listProofingType"
              url="/master/common/dict/biz"
              :body="proofingTypeParams"
              size="small"
              multiple
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item
            :label="$l('INDEX.proofing_label_demandTime') || '需求时间'"
          >
            <br />
            <el-row :gutter="10">
              <el-col :span="11">
                <el-date-picker
                  v-model="form.demandTimeStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="demandTimeStartPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.demandTimeEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="demandTimeEndPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      proofingTypeParams: { dictType: 'proofingType' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      //需求日期限制
      demandTimeStartPicker: this.demandTimeEnd(),
      demandTimeEndPicker: this.demandTimeStart(),
      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },

  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },

    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //需求时间限制
    demandTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.demandTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.demandTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    demandTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.demandTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.demandTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
